import React, { Component } from "react";
import { translate } from "react-polyglot";
import { Col } from "reactstrap";
import { Subscribe } from "unstated";
import { BuildupTemplate, Image } from "../../generated/graphql";
import FilterState from "../../state/FilterState";
import OfflineData from "../../state/OfflineData";
import BasicSelect from "../fields/BasicSelect";

class OfflineTemplateSelect extends Component {
  constructor(props: {}) {
    super(props);

    this.findParameters = this.findParameters.bind(this);
  }

  public findParameters(
    handleTemplateSelect: (
      parameters: string[],
      templateId: string,
      imageLocation: string
    ) => void,
    templates: Array<
      {
        __typename?: "BuildupTemplate";
      } & Pick<
        BuildupTemplate,
        "id" | "name" | "description" | "parameters"
      > & {
          images: Array<
            {
              __typename?: "Image";
            } & Pick<Image, "id" | "name" | "location">
          >;
        }
    >,
    templateId: string
  ) {
    const selectedTemplate = templates.find(template => {
      return template.id === templateId;
    });
    if (selectedTemplate) {
      handleTemplateSelect(
        selectedTemplate.parameters,
        templateId,
        selectedTemplate.images[0].location
      );
      return selectedTemplate.parameters;
    }
    return {};
  }

  public render() {
    return (
      <Col className="pt-2 col-12">
        <Subscribe to={[FilterState, OfflineData]}>
          {(filterState: any, offlineData: any) => {
            const handleTemplateSelect = (
              parameters: string[],
              templateId: string,
              imageLocation: string
            ) =>
              filterState.handleTemplateSelect(
                parameters,
                templateId,
                imageLocation
              );
            const templateIdFilter = filterState.state.filters.find(
              (f: any) => f.parameter === "templateId"
            );

            const templates = offlineData.state.templates.map(
              (template: any) => {
                return {
                  label: template.name,
                  value: template.id
                };
              }
            );

            return (
              <BasicSelect
                options={templates}
                fieldName="templateId"
                paramOperator="contains"
                defaultValue={templates[0]}
                value={templateIdFilter ? templateIdFilter.values[0] : null}
                handleSelect={(e: any) =>
                  this.findParameters(
                    handleTemplateSelect,
                    offlineData.state.templates,
                    e
                  )
                }
              />
            );
          }}
        </Subscribe>
      </Col>
    );
  }
}

export default translate()(OfflineTemplateSelect);
